import React, {useState} from "react";
import styles from "./CellStyle.module.css";
import {Modal, CloseButton} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export default function CardTextModalPreview(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'cardTextModal'});
    const [showPrivateNotes, setShowPrivateNotes] = useState(false)


    return (
        <Modal
            show={props.modalOpened }
            onHide={props.closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={styles.modaltext}
            dialogClassName={styles.modaldialog}
        >
            <div style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "absolute",
                right: "0px",
                top: "0px"
            }}>
                <CloseButton
                    style={{margin: "16px"}}
                    onClick={props.closeModal}
                />
            </div>
            <div style={{
                backgroundImage: "url(" + props.background.background_image_url + ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: props.background.image_height,
                width: props.background.image_width,
                paddingTop: props.background.padding_top,
                paddingBottom: props.background.padding_bottom,
                paddingLeft: props.background.padding_left,
                paddingRight: props.background.padding_right,
                color: props.background.font_color,
                borderRadius: "6px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "bolder",
                    fontSize: "36px",
                    fontFamily: 'Tenor Sans'
                }}>{props.cellNumber}</div>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "24px",
                    fontFamily: 'Tenor Sans'
                }}>
                    {props.card.title}
                </div>
                <div style={{
                    fontWeight: "normal",
                    fontSize: "20px",
                    overflow: "auto",
                    minHeight: "120px"
                }}>
                    {props.card.card_text}
                </div>
                {
                    props.mentor_notes &&
                    <>
                        <br/>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            fontSize: "24px",
                            gap: "12px",
                            fontFamily: 'Tenor Sans'
                        }}>
                            {t('privateNotes')} {
                            showPrivateNotes ?
                                <VisibilityOffIcon
                                    style={{cursor: "pointer"}}
                                    onClick={() => setShowPrivateNotes(false)}
                                />
                                :
                                <VisibilityIcon
                                    style={{cursor: "pointer"}}
                                    onClick={() => setShowPrivateNotes(true)}
                                />
                        }
                        </div>

                        {showPrivateNotes && <div
                            style={{
                                fontWeight: "normal",
                                fontSize: "20px",
                                overflow: "auto",
                                minHeight: "120px"
                            }}
                        >{props.mentor_notes}</div>}

                    </>
                }



            </div>
        </Modal>
    )
}